import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '@pc-ui/icon';
import { MessageComponent } from './message.component';

@NgModule({
  declarations: [MessageComponent],
  imports: [CommonModule, IconModule],
  exports: [MessageComponent],
})
export class MessageModule {}
